export const logoutUser = () => {
    localStorage.removeItem('token')
}

export const isAuth = () => {
    return localStorage.getItem('token')
}
